<!-- eslint-disable prettier/prettier -->
<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container">
      <div class="quoteleft">
        <div class="title">Personal Property Add-On</div>
        <br />
        <span class="poweredby">Provided by NSSI</span>
        <br /><br />
        <status-component />
        <input
          id="addpp"
          v-model="quote.hasPersonalInsurance"
          type="checkbox"
          class="styledchecked"
          name="liability-ded"
          :true-value="true"
          @change="nssiQuoteChange"
        />
        <label for="addpp" class="subtitle" style="color: #414142">
          Add Accidental Damage Coverage
        </label>
        <help-popup
          msg="Covers your phone, laptop, camera, headphones --- from accidental drops, cracked screens or liquid damage."
        />
        <br /><br /><br />
        <!----->
        <div v-if="quote.hasPersonalInsurance">
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="policyoptionstable"
          >
            <tbody>
              <tr>
                <td width="30%">
                  <strong class="subsubtitle">Coverage</strong>
                  <red v-pre>*</red>
                  <help-popup
                    msg="The maximum payout per claim."
                    help-class="help smallhelp"
                  ></help-popup>
                </td>
                <td align="right">
                  <select
                    v-model="quote.personalInsurance.coverageAmount"
                    style="width: 60%"
                    name="coverageAmount"
                    :class="{ validationfield: hasErrors('coverageAmount') }"
                    :disabled="!nssiCoverages[0]"
                    @change="nssiQuoteChange"
                  >
                    <option value="0">Please Select...</option>
                    <option
                      v-for="coverage in nssiCoverages[0]"
                      :key="coverage.value"
                      :value="coverage.value"
                    >
                      {{ coverage.text }}
                    </option>
                  </select>
                  <validation-error name="coverageAmount" :errors="validationErrors" />
                </td>
              </tr>
            </tbody>
          </table>
          <!----->
          <table
            v-if="showDec"
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="policyoptionstable"
          >
            <tbody>
              <tr>
                <td width="30%">
                  <strong class="subsubtitle">Deductible</strong>
                  <red v-pre>*</red>
                  <help-popup
                    msg="A deductible is the amount the policyholder must pay before the insurer pays out
                                            the claim."
                    help-class="help smallhelp"
                  />
                </td>
                <td align="right">
                  <template v-for="deductible in nssiDeductibles">
                    <input
                      :id="'pp-ded-' + deductible.value"
                      v-model="quote.personalInsurance.deductibleAmount"
                      type="radio"
                      class="styledradio"
                      name="personalDeductible"
                      :value="deductible.value"
                      @change="nssiQuoteChange"
                    />
                    <label
                      name="personalDeductible"
                      :for="'pp-ded-' + deductible.value"
                      :class="{
                        validationfield: hasErrors('personalDeductible'),
                      }"
                      style="margin-left: 5px !important"
                      @click="validatedFieldChanged"
                    >
                      {{ deductible.text }}
                    </label>
                  </template>
                  <validation-error name="personalDeductible" :errors="validationErrors" />
                </td>
              </tr>
            </tbody>
          </table>
          <!------>
          <!----->
          <table
            v-if="showDec"
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="policyoptionstable"
          >
            <tbody>
              <tr>
                <td width="30%">
                  <strong class="subsubtitle">Payment Options</strong>
                  <red v-pre>*</red>
                  <help-popup
                    msg="Choose a payment plan that's best for you: monthly or annual."
                    help-class="help smallhelp"
                  />
                </td>
                <td align="right">
                  <input
                    id="pp-paymentplan-monthly"
                    v-model.number="quote.personalInsurance.paymentOption"
                    type="radio"
                    class="styledradio"
                    name="personalLiabilityPaymentPlan"
                    :value="1"
                    @change="nssiQuoteChange"
                  />
                  <label
                    name="personalLiabilityPaymentPlan"
                    for="pp-paymentplan-monthly"
                    :class="{
                      validationfield: hasErrors(
                        'personalLiabilityPaymentPlan'
                      ),
                    }"
                    style="margin-left: 5px !important"
                    @click="validatedFieldChanged"
                  >
                    Monthly
                  </label>
                  <input
                    id="pp-paymentplan-annual"
                    v-model.number="quote.personalInsurance.paymentOption"
                    type="radio"
                    class="styledradio"
                    name="personalLiabilityPaymentPlan"
                    :value="2"
                    @change="nssiQuoteChange"
                  />
                  <label
                    name="personalLiabilityPaymentPlan"
                    for="pp-paymentplan-annual"
                    :class="{
                      validationfield: hasErrors(
                        'personalLiabilityPaymentPlan'
                      ),
                    }"
                    style="margin-left: 5px !important"
                    @click="validatedFieldChanged"
                  >
                    Annual
                  </label>
                  <validation-error name="personalLiabilityPaymentPlan" :errors="validationErrors" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!----->
        <div class="spacer"></div>
        <hr />
        <div class="spacer"></div>
        <!--------------------------------------------------->
        <div style="text-align: center">
          <button :class="{ disabled: !validated }" @click="goToPage('quote-account')">
            Continue
          </button>
        </div>
        <br /><br /><br /><br /><br /><br />
      </div>
      <!--------------------------------------------------------------------------------------------->
      <quote-cart />
    </div>
  </section>
</template>

<script lang="ts" setup>
import QuoteCart from "@/views/quote/QuoteCart.vue";
import HelpPopup from "@/components/HelpPopup.vue";
import { scrollMeTo, stat } from "@/utils/Utils";
import { NssiData } from "@/api/NssiData";
import { PaymentOptions } from "@/models/QuoteInsurance";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import ValidationError from "@/components/ValidationError.vue";
import ProductService from "@/services/ProductService";
import { inject, onMounted, ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useStatusStore } from "@/stores/root/status";
import { useProductStore } from "@/stores/root/products";
import { watch } from "vue";

const props = defineProps({
  anchor: {
    type: String,
    default: "",
  },
});
const title = "Add-On";
const quote = useQuoteStore();
const productStore = useProductStore();
const loading: Ref<boolean> = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const nssiCoverages: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const inj = inject("$emitter");
const options = ref<any[]>([]);
const selectedCoverage = ref();
const showDec = ref(false);
const ratingType = ref("");
const policyTermsArray = ref<any[]>([]);
const coverageTypes = ref<any[]>([]);

const getCoverages = async () => {
  try {
    const products = await ProductService.all();
    if (products[0].rating_type) ratingType.value = products[0].rating_type;
    console.log("Products:", products[0]);
    nssiCoverages.value.push(products[0].coverage_amounts);
    options.value = products[0].coverage_amounts ?? [];
    console.log(options.value);
  } catch (error) {
    throw "Products load error";
  }
};

onMounted(() => {
  getCoverages();

  if (
    productStore &&
    productStore.products[0] &&
    productStore.products[0].coverage_amounts
  ) {
    console.log("Product", productStore.products[0].coverage_amounts);
    selectedCoverage.value = productStore.products[0].coverage_amounts.find(
      function (item) {
        return (
          Number(item.value) === Number(quote.personalInsurance.coverageAmount)
        );
      }
    );
    console.log("selectedCoverage:", selectedCoverage.value);
    //showDec.value = true;
  }
});

const validated = computed(() => {
  const personalValidate =
    quote.personalInsurance.coverageAmount > 0 &&
    quote.personalInsurance.deductibleAmount &&
    quote.personalInsurance.paymentOption;

  return quote.hasPersonalInsurance ? personalValidate : true;
});
watch(
  function () {
    return quote.personalInsurance.coverageAmount;
  },
  function (newValue) {
    selectedCoverage.value = options.value.find(function (item) {
      return item.value === newValue;
    });
    quote.personalInsurance.deductibleAmount = 0;
    quote.personalInsurance.paymentOption = PaymentOptions.None;
    policyTermsArray.value = selectedCoverage.value
      ? selectedCoverage.value.policy_terms
      : [];
    coverageTypes.value = selectedCoverage.value
      ? selectedCoverage.value.coverage_types
      : [];
    if (selectedCoverage.value && selectedCoverage.value.deductibles) {
      showDec.value = true;
    }
    console.log("changedCoverage:", selectedCoverage.value);
  }
);
watch(
  function () {
    return quote.personalInsurance.deductibleAmount;
  },
  function (newValue) {
    quote.personalInsurance.deductibleAmountText = nssiDeductibles.value.find(
      function (item: any) {
        return item.value === newValue;
      }
    )?.text;
    // quote.personalInsurance.deductibleAmount = 0;
    // quote.personalInsurance.paymentOption = PaymentOptions.None;
    // if (selectedCoverage.value && selectedCoverage.value.deductibles) {
    //   showDec.value = true;
    // }
    console.log("dec", quote.personalInsurance.deductibleAmountText);
    console.log("changed:", newValue);
  }
);

function createValidationMessages(): void {
  validationErrors.value.length = 0;

  if (!(quote.personalInsurance.coverageAmount > 0)) {
    const error = {
      name: "coverageAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }

  if (!(quote.personalInsurance.deductibleAmount > 0)) {
    const error = {
      name: "personalDeductible",
      value: "Deductible is required.",
    };
    validationErrors.value.push(error);
  }

  if (!(quote.personalInsurance.paymentOption > 0)) {
    const error = {
      name: "personalLiabilityPaymentPlan",
      value: "Payment option is required.",
    };
    validationErrors.value.push(error);
  }
}

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollMeTo("status");
    return;
  }
  quote.setQuoteStep(command);
}

const readNssiRates = async () => {
  const ratesResult = await NssiData.getRates(quote);
  if (ratesResult.error) {
    stat(statusStore).error(ratesResult.message);
    scrollMeTo("status");
  } else {
    if (ratesResult.result.rates && ratesResult.result.rates[0]) {
      const rate = ratesResult.result.rates[0];
      console.log("RATE", rate);
      console.log("PaymentOptions", PaymentOptions);
      quote.personalInsurance.annualAmount = rate.full_term_premium;
      quote.personalInsurance.monthlyAmount = rate.installment_premium;
      quote.personalInsurance.installmentAmount = rate.installment_premium;
      quote.monthlyProcessingFee = rate.installment_proc_fee;
      quote.processingFee = rate.full_term_proc_fee;
      quote.personalInsurance.monthlyProcessingFee = rate.installment_proc_fee;
      quote.personalInsurance.fullTermTotal = rate.full_term_total;
      quote.personalInsurance.installmentTotal = rate.installment_total;
      quote.personalInsurance.processingFee = rate.full_term_proc_fee;
      quote.personalInsurance.discount = rate.discount;
      quote.personalInsurance.installmentDiscount = rate.installment_discount;
      quote.personalInsurance.policyTerms = policyTermsArray.value;
      quote.personalInsurance.coverageTypes = coverageTypes.value;
      quote.personalInsurance.sku = rate.SKU;
      quote.personalInsurance.term = rate.term;
      quote.personalInsurance.processingFeeSku =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.ProcessingFeeSKU_Installment
          : rate.ProcessingFeeSKU;
      quote.personalInsurance.dueToday =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.installment_total
          : rate.full_term_total;
      quote.personalInsurance.retailPremium =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.installment_total
          : rate.full_term_total;
    }
  }
};

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  if (!event || !event.target || !event.target.name) {
    return;
  }
  clearValidationMessage(event.target.name);
}

const quoteChange = async (event: any) => {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
};

const nssiQuoteChange = async (event: any) => {
  if (
    quote.hasPersonalInsurance &&
    quote.personalInsurance.coverageAmount &&
    quote.personalInsurance.deductibleAmount
  ) {
    loading.value = true;
    stat(statusStore).clear();
    await readNssiRates();
    loading.value = false;
    quote.showAddonOnCart = true;
  }
  quoteChange(event);
};

const nssiDeductibles: ComputedRef<any> = computed(() => {
  return selectedCoverage.value && selectedCoverage.value.deductibles
    ? selectedCoverage.value.deductibles
    : [];
  //return NssiData.deductibles;
});

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}
</script>
